import EffectAmount from '@/roc/effects/EffectAmount';
class ProductionCost extends EffectAmount {
    __currency;
    constructor(calc, amount, currency = null) {
        super(calc, amount);
        this.__currency = currency;
    }
    withCurrency(currency) {
        return new ProductionCost(this.__calc, this.__amount, currency);
    }
}
export default ProductionCost;
